import { useQuery } from '@tanstack/react-query';

import { getCallTranscribeFn } from './utils';

import type { GetCallTranscribeProps } from './types';

export type UseGetCallTranscribeProps = GetCallTranscribeProps & {
  enabled: boolean;
};

export const useGetCallTranscribe = (props: UseGetCallTranscribeProps) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['call-transcribe', props],
    queryFn: async () => getCallTranscribeFn(props),
    enabled: props.enabled,
    staleTime: Infinity,
  });

  return {
    transcripts: data,
    getCallTranscribeLoading: isLoading,
    callTranscribeErrorMessage:
      error instanceof Error ? error.message : undefined,
  };
};
